export default "__VITE_ASSET__2e1f4317__"